(() => {
  function enhance(root = document) {
    root.querySelectorAll('[data-asos-editorial-content]:not([data-editorial-ready])').forEach(body => {
      body.dataset.editorialReady = 'true';
      body.querySelectorAll('[style]').forEach(el => {
        ['color','background-color','background','font-family','font-size','line-height','margin-bottom','margin-top'].forEach(prop => el.style.removeProperty(prop));
      });
      body.querySelectorAll('meta').forEach(el => el.remove());
      body.querySelectorAll('p,h1,h2').forEach(el => {
        if (!el.textContent.replace(/\s|\u00a0/g, '') && !el.querySelector('img,video,iframe,input')) el.remove();
      });
      const firstTitle = body.querySelector('h1');
      if (firstTitle) {
        const sourceTitle = firstTitle.textContent.trim().toLocaleLowerCase('pt-BR');
        const pageTitle = (body.dataset.pageTitle || '').trim().toLocaleLowerCase('pt-BR');
        if (sourceTitle && pageTitle.includes(sourceTitle)) firstTitle.remove();
        else {
          const heading = document.createElement('h2');
          heading.innerHTML = firstTitle.innerHTML;
          heading.className = 'asos-editorial__source-title';
          firstTitle.replaceWith(heading);
        }
      }
      const children = Array.from(body.childNodes);
      const fragment = document.createDocumentFragment();
      let card = null;
      children.forEach(node => {
        if (node.nodeType === 1 && /^H[12]$/.test(node.tagName)) {
          card = document.createElement('div');
          card.className = 'asos-editorial__card';
          fragment.appendChild(card);
        }
        if (!card) {
          card = document.createElement('div');
          card.className = 'asos-editorial__card asos-editorial__lead';
          fragment.appendChild(card);
        }
        card.appendChild(node);
      });
      body.appendChild(fragment);
      body.querySelectorAll('.asos-editorial__card').forEach(card => {
        if (!card.textContent.trim() && !card.querySelector('img,video,iframe')) card.remove();
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => enhance());
  else enhance();
  document.addEventListener('shopify:section:load', event => enhance(event.target));
})();